import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { createLoginRedirectUrl } from 'utils/redirectUtils';
import { isPlatformAdministrator } from 'utils/platformAdmin';

const PlatformAdminRoute = ({
  component: Component,
  authState = {},
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      const { authInfo = {}, isAuth } = authState;
      const { groups = [] } = authInfo;

      if (!isAuth || !isPlatformAdministrator(groups)) {
        const {
          location: { pathname = '/', search = '' },
        } = props;

        const { reLoginData } = authState;
        const loginUrl = createLoginRedirectUrl(pathname, search, reLoginData);

        return <Redirect to={loginUrl} />;
      }

      return <Component {...props} />;
    }}
  />
);

PlatformAdminRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  authState: PropTypes.object,
};

const mapStateToProps = ({ authState }) => ({
  authState,
});

export default connect(mapStateToProps)(PlatformAdminRoute);
